import { type LegacyWorkflowError } from '@blaze-shared/workflow-domain';

import {
  ColumnMissingIntellisenseError,
  InputMissingIntellisenseError,
  type IntellisenseError,
  InvalidFieldValueIntellisenseError,
  InvalidFormulaIntellisenseError,
  ScopeVarMissingIntellisenseError,
  TagMissingIntellisenseError,
} from './models/intellisense-error';

export function mapWorkflowErrorsToIntelliErrors(
  wfErrors: LegacyWorkflowError[],
): IntellisenseError[] {
  const errors: IntellisenseError[] = [];

  for (const wfError of wfErrors) {
    switch (wfError.errorType) {
      case 'COLUMN_MISSING_ERROR':
        errors.push(new ColumnMissingIntellisenseError(wfError.errorMessage, wfError.columnId));
        break;
      case 'INVALID_FIELD_VALUE_ERROR':
        errors.push(new InvalidFieldValueIntellisenseError(wfError.errorMessage, wfError.fieldId));
        break;
      case 'SCOPE_VAR_MISSING_ERROR':
        errors.push(new ScopeVarMissingIntellisenseError(wfError.errorMessage, wfError.varName));
        break;
      case 'INPUT_MISSING_ERROR':
        errors.push(new InputMissingIntellisenseError(wfError.errorMessage, wfError.inputName));
        break;
      case 'INVALID_FORMULA_ERROR':
        errors.push(new InvalidFormulaIntellisenseError(wfError.errorMessage));
        break;
      case 'TAG_MISSING_ERROR':
        errors.push(new TagMissingIntellisenseError(wfError.errorMessage, wfError.tagId));
        break;
    }
  }

  return errors;
}
